import { Component, OnInit } from '@angular/core';
import { AbstractCallComponent } from '../abstract-call/abstract-call.component';
import { EExternalIntegrationCallType, EOnError, EOperator } from '../../tp-integrations.interface';

@Component({
    selector: 'se-error-call',
    templateUrl: './error-call.component.html',
    styleUrls: ['../call-style/call.scss'],
})
export class ErrorCallComponent extends AbstractCallComponent implements OnInit {
    ngOnInit(): void {
        super.ngOnInit();

        const callType = this.call.type;
        if (!EExternalIntegrationCallType[callType]) {
            this.call.description = 'Error';
            if (!this.call.errorHandling) {
                this.call.errorHandling = {
                    operator: EOperator.EQUAL,
                    message: 'Call type not supported',
                    valueTrigger: '',
                    path: '',
                    action: EOnError.BREAK,
                };
            }
            if (this.call.errorHandling) this.call.errorHandling.message = `${callType} Call type not supported`;
        }
    }

    close() {
        this.callThrowError.emit('FORCE_CLOSE');
    }
}
